/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import MolGrid from "../../components/Grid/MolGrid";
import { hasFunctionalPermission } from "../../utils/authorizeNavigation/authorizeNavigation";
import { securityKey } from "../../data/SecurityKey";
import { MainCategoryListGridConfig } from "./MainCategoryList.Data";
import SwalAlert from "../../services/swalService/SwalService";
import { useDeleteMainSkillMutation, useGetMainSkillMutation } from "../../app/services/mainSkillCategoriesAPI";
import ToastService from "../../services/toastService/ToastService";
import SidebarModel from "../../components/ui/sidebarModel/SidebarModel";
import AddSubSkill from "../skills/subSkill/AddSubSkill";
import moment from "moment/moment";

const MainCategoryList = forwardRef((props, ref) => {
  const { confirm } = SwalAlert();
  const molGridRef = useRef();
  const [listData, setListData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [mainSkillId, setMainSkillId] = useState(null);

  const [getSkillCategories, { isLoading: isListLoading, isSuccess: isListSuccess, data: isListeData },] = useGetMainSkillMutation();
  const [deleteSkillCategories, { isSuccess: isDeleteSkillCategoriesSuccess, data: isDeleteSkillCategoriesData },] = useDeleteMainSkillMutation();

  const hasEditPermission = hasFunctionalPermission(securityKey.EDITMAINSKILL);
  const hasDeletePermission = hasFunctionalPermission(securityKey.DELETEMAINSKILL);
  const hasAddSubSkillPermission = hasFunctionalPermission(securityKey.ADDSUBSKILL);

  const actionColumn = MainCategoryListGridConfig.columns.find(column => column.name === "Action");

  //** Funcation's */
  const getLists = (pageObject) => {
    getSkillCategories(pageObject);
  };

  //** Handle Changes */
  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: props.search },
    };
    getLists(request);
  };

  useEffect(() => {
    if (hasEditPermission?.isViewOnly === true) {
      actionColumn.defaultAction.allowEdit = true;
    }
    else if (hasEditPermission?.isEditable === true) {
      actionColumn.defaultAction.allowEdit = true;
    }
    else {
      actionColumn.defaultAction.allowEdit = false;
    }
  }, [hasEditPermission, actionColumn?.defaultAction?.allowEdit]);

  useEffect(() => {
    if (hasDeletePermission?.hasAccess === true) {
      actionColumn.defaultAction.allowDelete = true;
    }
    else if (hasDeletePermission?.hasAccess === false) {
      actionColumn.defaultAction.allowDelete = false;
    }
  }, [hasDeletePermission, actionColumn?.defaultAction?.allowDelete]);

  const securityValidator = (hasAccess, customAction, actionName) => {
    return customAction && customAction?.map(action => action?.name === actionName ? { ...action, isActive: hasAccess } : action);
}
  useEffect(() => {
    
    if (hasAddSubSkillPermission?.hasAccess === true) {
      actionColumn.customAction = securityValidator(
        hasAddSubSkillPermission?.hasAccess,
        actionColumn.customAction,
        "ADDSUBSKILLS"
      );
    } 
    else{
      actionColumn.customAction = false
    }
  }, [hasAddSubSkillPermission, actionColumn?.defaultAction?.allowAddSubSkill]);
  

  //** UseEffect */
  useEffect(() => {
    if (isListSuccess && isListeData) {
      if (isListeData) {
        const modifyCustomerData = isListeData.dataSource.map((data) => ({
          ...data,
          updatedAt: data.updatedAt ? moment(data.updatedAt).format("DD/MM/YYYY hh:mm A") : "-",
          updatedByFullName: data.updatedByFullName === null ? "-" : data.updatedByFullName,
        }));
        setListData(modifyCustomerData);
      }
      if (isListeData.totalRecord > 0 || isListeData.totalRecord === 0) {
        setTotalRowCount(isListeData.totalRecord);
      }
    }
  }, [isListSuccess, isListeData]);

  useEffect(() => {
    if (isDeleteSkillCategoriesSuccess && isDeleteSkillCategoriesData) {
      ToastService.success(isDeleteSkillCategoriesData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getLists(request);
    }
  }, [isDeleteSkillCategoriesSuccess, isDeleteSkillCategoriesData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getLists(request);
    }
  }, [props.search]);

  useEffect(() => {
    if (ref) {
      ref.current = {
        refreshGrid: () => {
          if (molGridRef.current) {
            const currentPageObject = molGridRef.current.getCurrentPageObject();
            const request = {
              pagination: {
                pageNumber: currentPageObject.pageNumber,
                pageSize: currentPageObject.pageSize,
              },
              filters: { searchText: props.search },
            };
            getLists(request);
          }
        },
      };
    }
  }, [ref]);

  //** Action Method's */
  const handleEditClick = (data) => {
    if (props.onEdit) {
      props.onEdit(data);
    }
  };

  const handleDeleteClick = (data) => {
    confirm("Delete?", "Are you sure you want to Delete?", "Delete", "Cancel")
      .then((confirmed) => {
        if (confirmed) {
          deleteSkillCategories(data.mainSkillId);
        }
      });
  };

  const handleAddSubSkills = (data) => {
    setMainSkillId(data.mainSkillId)
    setIsModelOpen(true);
  };

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick,
    ADDSUBSKILLS: handleAddSubSkills
  };

  const onCloseSidebar = () => {
    setIsModelOpen(false);
  }

  return (
    <>
      <div className="table-body-scroll">
        <MolGrid
          ref={molGridRef}
          configuration={MainCategoryListGridConfig}
          dataSource={listData}
          allowPagination={true}
          pagination={{
            totalCount: totalRowCount,
            pageSize: 20,
            currentPage: 1,
          }}
          isLoading={isListLoading}
          onActionChange={actionHandler}
          onPageChange={handlePageChange}
        />
      </div>
      <SidebarModel
        modalTitle={`Sub Skills`}
        modalSize="w-45"
        onClose={onCloseSidebar}
        isOpen={isModelOpen}
      >
        <div className="sub-skill-detail">
          <AddSubSkill onCloseSidebar={onCloseSidebar} mainSkillId={mainSkillId} isModelOpen={isModelOpen} />
        </div>
      </SidebarModel>
    </>
  );
});

export default MainCategoryList;
